export enum ActivityAction {
  SceneElements = 'SceneElements', // Generating SceneElements from script
  SceneElementImage = 'SceneElementImage', // Generating image for a SceneElement
  Storyboard = 'Storyboard', // Generating shots for a storyboard
  ShotImage = 'ShotImage', // Generating image for a shot
  SyntheticData = 'SyntheticData',
  Upscale = 'Upscale',
  UserImage = 'UserImage',
  PlaygroundImage = 'PlaygroundImage',
  VideoThumbnail = 'VideoThumbnail',
  VideoPreview = 'VideoPreview',
}
